import { EmptyState } from '@personachat/ui';
import { ShieldAlert } from 'lucide-react';

export function ForbiddenPage() {
  return (
    <EmptyState
      icon={<ShieldAlert size={28} />}
      title="Réservé au super admin"
      text="Votre rôle ne donne pas accès à cet écran. Demandez à un super admin si vous en avez besoin."
    />
  );
}
